import { consume } from '@lit/context';
import { t } from 'i18next';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { GlobalComponentType, global } from '@/context';
import { baseStyles, stepContainerStyles } from '@/styles';
import { ApiService } from '@/types';
import { uploadFileToEndpoint } from '@/utils';

import '../../loader/fg-loader';

@customElement('fg-personalisation-uploading')
export class FgPersonalisationUploading extends LitElement {
  @property({ type: Object })
  file?: File;

  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  async firstUpdated() {
    if (!this.file) {
      return;
    }

    const formData = {
      file: this.file,
    };

    uploadFileToEndpoint(
      this,
      formData,
      ApiService.LOGO,
      'personalisation-uploaded',
      'upload-error',
      this.globalContext.locale,
    );
  }

  render() {
    return html`
      <div class="step-container">
        <fg-loader
          type="configuration"
          .label=${t('labels.uploading')}
        ></fg-loader>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    stepContainerStyles,
    css`
      span {
        margin-top: 15px;
      }
    `,
  ];
}
